import { useEffect, useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function usePrevious<T = any>(val: T): T | undefined {
  const ref = useRef<T>()
  useEffect(() => {
    ref.current = val
  })
  return ref.current
}
